<template>
    <div class="flex-shrink-0 flex items-center lg:gap-3 w-full">
        <img class="block h-16 w-auto" src="/images/logo/pitch-logo.svg" alt="Pitch Logo" />
        <h1 class="text-white font-bold text-3xl">Pitch</h1>
    </div>
</template>
